import { ValueCallback } from "shared/core/types/callbacks";
import { DivisionLookupModel, useListClientDivisionsFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { Select, SelectProps } from "shared/UI/Select/Select";

interface DivisionSelectProps extends SelectProps {
  clientId: string;
  onSelection: ValueCallback<DivisionLookupModel | undefined>;
  value: string;
  ariaLabel: string;
  placeholder: string;
}

export const DivisionSelect = ({ clientId, onSelection, value, ariaLabel, placeholder }: DivisionSelectProps) => {
  const { data: divisionsData } = useListClientDivisionsFunctionRequest({ clientId });

  return (
    <div className="w-1/2">
      <Select
        onChange={(e) => {
          const division = divisionsData?.divisions?.find((division) => division.id === e.target.value);
          onSelection(division);
        }}
        aria-label={ariaLabel}
        value={value ?? ""}
      >
        <option value={""}>{placeholder}</option>
        {divisionsData?.divisions &&
          divisionsData.divisions.map((division) => (
            <option key={division.id} value={division.id}>
              {division.name}
            </option>
          ))}
      </Select>
    </div>
  );
};
